import { createElement } from "@/utils/create-elem.js";
import { saveBtn } from "./saveBtn.js";
import { continueBtn } from "./continueBtn.js";
import { resetBtn } from "./resetBtn.js";
import { solutionBtn } from "./solutionBtn.js";

export function ControlsBar(parent) {
  const controlsBar = createElement({
    tag: "div",
    classes: ["controls-bar"],
    parent: parent,
  });

  saveBtn(controlsBar);
  continueBtn(controlsBar);
  resetBtn(controlsBar);
  solutionBtn(controlsBar);
}
